// LD Configurator data
var LD;
const londonDynamicsCustomerId = "1145a845-7aff-442e-8780-09ed62fa1d3a";

// This object is mutated as the user's selections change. We will use this to calculate the final cart.
// The keys of this object are the `optionKey`s below.
let latestOptions = {
};

// A handle to the LD widget itself
let widget;

// The base model is computed from the strap and basket variants.
const BASE_MODEL_MAP = {
  'resort-strap': {
    'resort-basket': 'resort-resort',
    'powder-basket': 'resort-powder',
  },
  'magstrap': {
    'resort-basket': 'mag-resort',
    'powder-basket': 'mag-powder',
  }
};

const OUT_OF_STOCK_SHAFTS = {
//  '110 CM': ['powder-day','bluebird'],
 '115 CM': ['powder-day']

};

document.addEventListener("DOMContentLoaded", async function () {
  console.log("P1 CUSTOMIZER MODAL JS FILE EXECUTED ...... ");

  const productHandle = getProductHandleFromUrl(window.location.href);
  // TODO we could put this in metafields?
  let customizerProductHandle;
  let londonDynamicsSku;
  switch (productHandle) {
    case 'p1-poles':
      customizerProductHandle = 'custom-p1-poles';
      londonDynamicsSku = 'p1';
      // NOTE: do not remove these default values. This logic is needed in order to set the default variants
      latestOptions = {
        'strap-variant': 'resort-strap',
        'basket-variant': 'resort-basket',
      }
      break;
    case 'p2-poles':
      customizerProductHandle = 'custom-p2-poles';
      londonDynamicsSku = 'p2';
      // NOTE: do not remove these default values. This logic is needed in order to set the default variants
      latestOptions = {
        'strap-variant': 'magstrap',
        'basket-variant': 'powder-basket',
      }
      break;
    case 'p1-mini-poles':
      customizerProductHandle = 'custom-p1-mini-poles';
      londonDynamicsSku = 'p1-mini';
      // NOTE: do not remove these default values. This logic is needed in order to set the default variants
      latestOptions = {
        'strap-variant': 'resort-strap',
        'basket-variant': 'resort-basket',
      }
      break;
    default:
      console.error("No customizer product handle for this product", productHandle);
      break;
  }

  const addToCartButton = document.getElementById("customizer-add-to-cart");

  const productData = await fetchProductData(customizerProductHandle);  
  const productVariants = productData?.variants;
  console.log(productData);
  console.log('productVariants :', productVariants);

  const getMatchingVariant = (selectedStrap, selectedBasket) => {
      const matchingVariant = productVariants.find(variant => {
        const variantStrap = variant.option1;
        const variantBasket = variant.option2;
        return variantStrap == selectedStrap && variantBasket == selectedBasket;
      });
      if (!matchingVariant) {
        console.error("Could not find matching variant!", selectedStrap, selectedBasket);
      }
      return matchingVariant;
  };

  // There is a variant for every strap / basket combination since these affect the price.
  // This fetches the variant of the product based on the strap / basket selected by the user
  const defaultProductVariant = getMatchingVariant("Resort strap", "Resort basket");
  const getMatchingVariantForStrapAndBasket = (options) => {
      // resort-strap magstrap
      let selectedStrap;
      switch (options['strap-variant']) {
        case 'magstrap': selectedStrap = 'Magstrap'; break;
        case 'resort-strap': selectedStrap = 'Resort strap'; break;
      }
      let selectedBasket;
      switch (options['basket-variant']) {
        case 'powder-basket': selectedBasket = 'Powder basket'; break;
        case 'resort-basket': selectedBasket = 'Resort basket'; break;
      }
      return getMatchingVariant(selectedStrap, selectedBasket) || defaultProductVariant;
  };

  //
  // Util functions for updating user selections
  //

  /** Generic util for handling update a of specific optionKey */
  function handleSelectionUpdate(target) {
    const optionKey = target.name;
    const value = target.value;
    console.log("selected", optionKey, value);

    latestOptions = {
      ...latestOptions,
      [optionKey]: value,
    };

    updateLondonDynamicsWidget(optionKey, value, latestOptions);

    updateCartDisplayPrice(latestOptions)

    handleSelectedProductVariant(optionKey, value);

    handleVisualOptionUpdates(target);

    updateDisabledOptions(optionKey, value);
  }

  /** Update the add to cart button with the updated price */ 
  function updateCartDisplayPrice(options) {
    const matchingVariant = getMatchingVariantForStrapAndBasket(options);
    const buttonText = addToCartButton.textContent;
    var oldPrice = buttonText.match(/\d+/)[0];
    addToCartButton.textContent = buttonText.replace(oldPrice, matchingVariant.price / 100); 
  }

  function updateDisabledOptions(optionKey, value) {
    if (optionKey != 'shaft-size') {
      return;
    }

    const shaftColorRadios = document.querySelectorAll('input[name="shaft-color"]');
    shaftColorRadios.forEach(r => r.disabled = false);

    const outOfStockShafts = OUT_OF_STOCK_SHAFTS[value] || [];
    outOfStockShafts.forEach(s => {
      const radio = document.querySelector(`input[name="shaft-color"][value="${s}"]`);
      radio.disabled = true;
    });

    const section = document.querySelector('.display-shaft-colors');
    const isSelectedOptionDisabled = section.querySelector('label.ld-swatch--selected:has(> input[disabled])');
    if (isSelectedOptionDisabled) {
      // Look up the first enabled option and select it
      const firstEnabledOption = section.querySelectorAll("label > input:not([disabled])")[0];
      handleSelectionUpdate(firstEnabledOption);
    }
  }

  /** For our option selectors, highlight the selected variant. */
  function handleVisualOptionUpdates(option) {
    if (option.tagName != 'INPUT') {
      return;
    }

    // Clear out all siblings' selected CSS class and select only the new item
    const label = option.parentElement;
    label.parentElement.querySelectorAll("label").forEach(item => item.classList.remove('ld-variant--selected', 'ld-swatch--selected'));
    if (label.classList.contains('ld-swatch')) {
      label.classList.add('ld-swatch--selected');
    } else if (label.classList.contains('ld-variant')) {
      label.classList.add('ld-variant--selected');
    }

    if (label.classList.contains('ld-swatch')) {
      // For color swatches, update the name of the displayed color too
      const labelName = label.getAttribute('name');
      const selectedColorDisplay = label.closest("fieldset.fieldset-color-grouping").querySelectorAll("span.selected-color-display")
      selectedColorDisplay.forEach(d => d.textContent = labelName);
    }
  }
  
  function handleSelectedProductVariant(optionKey, value) {
    // If we change the selected strap or basket variant, update which bundle of colors is shown and update
    // the item's price
    if (optionKey != 'strap-variant' && optionKey != 'basket-variant') {
      return;
    }

    const showSection = (section) => {
      section.style.display = 'block';
      // Select the first option in the new section that we're showing
      const firstOption = section.querySelector("label:nth-child(1) > input")
      handleSelectionUpdate(firstOption);
    };

    const strapResortDiv = document.querySelector('.display-strap-resort');
    const strapMagstrapDiv = document.querySelector('.display-strap-magstrap');
    const basketResortDiv = document.querySelector('.display-basket-resort');
    const basketPowderDiv = document.querySelector('.display-basket-powder');
    switch (value) {
      case 'magstrap':
        showSection(strapMagstrapDiv);
        strapResortDiv.style.display = 'none';
        break;
      case 'resort-strap':
        showSection(strapResortDiv);
        strapMagstrapDiv.style.display = 'none';              
        break;
      case 'powder-basket':
        showSection(basketPowderDiv);
        basketResortDiv.style.display = 'none';
        break;
      case 'resort-basket':
        showSection(basketResortDiv);
        basketPowderDiv.style.display = 'none';
        break;
    }
  }

  /** Given a key-value pair from the latestOptions, returns an object representing the corresponding update to send to the LD widget */
  const getLdWidgetUpdate = (optionKey, value, options) => {
    // Determine with LD feature IDs correspond to this optionKey
    let featureIds = []; 
    switch (optionKey) {
      case 'shaft-color': switch (productHandle) {
        case 'p1-poles': featureIds = ['color-left-fixed-shaft', 'color-right-fixed-shaft']; break;
        case 'p1-mini-poles': featureIds = ['color-left-adjustable-shaft', 'color-right-adjustable-shaft']; break;
        case 'p2-poles': featureIds = ['color-left-adjustable-shaft', 'color-right-adjustable-shaft']; break;
      } break;
      case 'strap-color': switch (options["strap-variant"]) {
        case "resort-strap": featureIds = ['color-left-strap', 'color-right-strap']; break;
        case "magstrap": featureIds = ['color-left-magstrap', 'color-right-magstrap']; break;
      } break;
      case 'basket-color': switch (options["basket-variant"]) {
        case "resort-basket": featureIds = ['color-left-resort-basket', 'color-right-resort-basket']; break;
        case "powder-basket": featureIds = ['color-left-powder-basket', 'color-right-powder-basket']; break;
      } break;
      case 'handle-color': featureIds = ['color-left-handle', 'color-right-handle']; break;
      // Not currently used
      case 'shaft-size': featureIds = ['size']; break;
    }

    const mapColorToLdVariant = (featureID, value) => {
      let color;
      switch (value) {
        case 'powder-day': color = 'white'; break;
        case 'ski-patrol': color = 'red'; break;
        case 'tree-run': color = 'green'; break;
        case 'sunlight': color = 'yellow'; break;
        case 'alpenglow': color = 'purple'; break;
        case 'double-black': color = 'black'; break;
        case 'bluebird': color = 'blue'; break;
        default: return value;
      }
      // Variants in london dynamics are prefixed with the featureID
      return `${featureID}-${color}`;
    };

    const widgetUpdate = Object.fromEntries(featureIds.map(k => [k, mapColorToLdVariant(k, value)]));
    return widgetUpdate;
  };

  function updateLondonDynamicsWidget(optionKey, value, options) {
    if (!widget) {
      return;
    }
    if (optionKey == "basket-variant" || optionKey == "strap-variant") {
      // Changing the variant will also select a new color, which will trigger this for the new color.
      // So don't need to do any logic when the optionKey changes
      return;
    }

    const newWidgetValues = {
      ...getLdWidgetUpdate(optionKey, value, options),
      // Always include the base model in every widget update, it will no-op if nothing changed
      'base-model': BASE_MODEL_MAP[options["strap-variant"]][options["basket-variant"]],
    };
    console.log("setting widget values", newWidgetValues);
    widget.setValues(newWidgetValues);
  }
 
  //
  // Register the color swatch and variant selectors handlers
  //
  const radios = document.querySelectorAll('input[name="shaft-color"], input[name="strap-color"], input[name="basket-color"], input[name="handle-color"], input[name="shaft-size"], input[name="strap-variant"], input[name="basket-variant"]');
  radios.forEach(radio => radio.addEventListener('click', () => {
    handleSelectionUpdate(radio);
  }));


  //
  // Set default values.
  // Since this page is used for multiple products and we don't have information of each product's variants,
  // use the DOM here.
  // We select the first option for each variant here and pass this through
  //

  const defaultsToSet = ["shaft-size", "shaft-color", "strap-variant", "basket-variant", "handle-color"];
  defaultsToSet.forEach(key => {
    const firstOption = document.querySelectorAll(`label > input[name="${key}"]:not([disabled])`)[0];
    handleSelectionUpdate(firstOption);
  });


  //
  // Modal Functionalities
  //

  // MODAL
  var modalCustomizer = document.getElementById("my-modal-customizer");
  const openCustomizerModal = () => {
    modalCustomizer.style.display = "block";
    loadLondonDynamicsWidget();
  };
  document.querySelectorAll("#open-modal-customizer").forEach(button => {
    if (customizerProductHandle) {
      // The "customize" button to open the modal is sometimes rendered outside the PDP, like on the quick add screen.
      // So, the button normally has an href to direct to the PDP screen and open the customizer.
      // If we are already on the PDP though, set the href to none and add the event handler to open the modal.
      button.href = "#";
      button.addEventListener("click", openCustomizerModal);
    }
  });
  document.querySelectorAll(".modalClose").forEach(m => m.addEventListener('click', () => {
    modalCustomizer.style.display = "none";
  }));
  window.onclick = function(event) {
    if (event.target === modalCustomizer) {
      modalCustomizer.style.display = "none";
    }
  };


  //
  // Load London Dynamics API
  //

  var tag = document.createElement("script");
  tag.src = "https://configurator.v2.londondynamics.com/iframe_api";
  tag.onload = function() {
    // Once london dynamics is ready and the LD variable is defined, check if we need to open the customize modal
    const url = new URL(window.location.href);
    const launchCustomizer = url.searchParams.get("customize")
    if (launchCustomizer) {
      openCustomizerModal();
      // Remove the customize key from the querystring
      url.searchParams.delete("customize");
      history.pushState("", document.title, url.toString());
    }
  };
  document.head.appendChild(tag);

  const widgetComponent = document.querySelector('#my-customizer-component');
  function loadLondonDynamicsWidget() {
    if (widget) {
      // Widget is already loaded
      return;
    }
    if (!LD || !LD.Widget) {
      // London dynamics script hasn't loaded, try again in a bit
      console.log("Waiting to load london dynamics widget, script hasn't loaded yet")
      setTimeout(loadLondonDynamicsWidget, 500);
      return;
    }
    const baseModel = BASE_MODEL_MAP[latestOptions["strap-variant"]][latestOptions["basket-variant"]];
    console.log("making widget", baseModel);
    widget = new LD.Widget(widgetComponent, {
      sku: londonDynamicsSku,
      customerId: londonDynamicsCustomerId,
      values: {
        "base-model": baseModel,
      },
      events: {
        onLoad: (options) => {
          // Given the latest options, apply the entire state of the widget and set the widget values.
          // This will catch any updates that were made while the widget was loading.
          let declarativeWidgetState = {};
          Object.entries(latestOptions).forEach(([key, value]) => {
            declarativeWidgetState = {
              ...declarativeWidgetState,
              ...getLdWidgetUpdate(key, value, latestOptions)
            };
          });
          console.log('Widget onLoad. Applying state', declarativeWidgetState);
          widget.setValues(declarativeWidgetState);
        },
        onReady: () => {
          console.log('Widget onReady');
        },
        onChange: (options) => {
          // console.log("Widget values changed", options)
        },
      },
      viewerSettings:{
        showConfigurator: false,
        showARButton: false,
        rotation: '180,0,0'
      },
    });
  };



  //
  // Add to Cart Functionality
  //
  addToCartButton.onclick = async function() {
    modalCustomizer.classList.add('modal-blur');

    if (!widget) {
      return;
    }

    // Get selected values from widget
    const {
      'shaft-size': size,
      'shaft-color': shaftColor,
      'strap-color': strapColor,
      'strap-variant': strapVariant,
      'basket-color': basketColor,
      'basket-variant': basketVariant,
      'handle-color': handleColor,
    } = latestOptions;
    console.log("Adding to cart", latestOptions)

    // Find the variant of the pole with the strap / basket options selected since this determines the price
    const matchingVariant = getMatchingVariantForStrapAndBasket(latestOptions);

    const userSelections = {
      // Note: these properties display in the oorder
      "Size": size,
      "Shaft": formatString(shaftColor),
      "Strap": `${formatString(strapColor)} (${formatString(strapVariant)})`,
      "Basket": `${formatString(basketColor)} (${formatString(basketVariant)})`,
      "Handle": formatString(handleColor),

      // These properties are just passed for processing by us. Don't change them unless you know what you're doing
      "_shaft-size": size,
      "_shaft-color": shaftColor,
      "_strap-color": strapColor,
      "_strap-variant": strapVariant,
      "_basket-color": basketColor,
      "_basket-variant": basketVariant,
      "_handle-color": handleColor,
      "_all_options": JSON.stringify(latestOptions),
    }

    const item = {
      id: matchingVariant.id,
      quantity: 1,
      properties: userSelections,
    };

    let formData = { items: [item] };

    // Send a single request to add multiple items to the cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then(response => response.json())
    .then(data => {
      modalCustomizer.classList.remove('modal-blur');
      modalCustomizer.style.display = "none";

      sessionStorage.setItem('showCartDrawer', 'true');
      window.location.reload();
    })
    .catch(error => console.error('Error adding to cart:', error));

  };
});

function getProductHandleFromUrl(url) {
  const newUrl = new URL(url);
  const urlParts = newUrl.pathname.split("/");
  const handle = urlParts[urlParts.length - 1];
  return handle;
}


async function fetchProductData(productHandle) {  
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching product data:", error);
    return null;
  }
}


function formatString(inputString) {
  let formattedStr = inputString.replace('-', ' ');
  
  formattedStr = formattedStr.split(' ').map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
  
  return formattedStr;
}


document.addEventListener('DOMContentLoaded', () => {
  if (sessionStorage.getItem('showCartDrawer') === 'true') {
    sessionStorage.removeItem('showCartDrawer');
    openCartDrawer();
  }
});


function openCartDrawer() {
  const cartDrawer = document.getElementsByClassName('drawer')[0];
  if (cartDrawer) {
    cartDrawer.classList.add('active');
    cartDrawer.classList.add('animate');
  }
}

